/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WellKnownService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Android App Links verification
     * Serves the Digital Asset Links file for Android App Links verification. Returns the dev or prod variant based on NODE_ENV.
     * @returns any Digital Asset Links JSON returned successfully.
     * @throws ApiError
     */
    public wellKnownControllerGetAssetLinks(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/.well-known/assetlinks.json',
        });
    }
    /**
     * iOS Universal Links verification
     * Serves the Apple App Site Association file for iOS Universal Links verification. Returns the dev or prod variant based on NODE_ENV.
     * @returns any Apple App Site Association JSON returned successfully.
     * @throws ApiError
     */
    public wellKnownControllerGetAppleAppSiteAssociation(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/.well-known/apple-app-site-association',
        });
    }
}
